import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { Communication, CommunicationType } from "./communications.types";

// One options factory per message kind. The same admin page and table serve
// every kind, bound to a different type.
export const communicationsQueryOptions = (type: CommunicationType) =>
	queryOptions({
		queryKey: ["admin", "communications", type],
		queryFn: () => api.get<Communication[]>(`/platform/communication?type=${type}`),
	});
